type HeroImage = { url: string; caption?: string | null };

/**
 * 拠点ページのヒーロー画像列を組み立てる。
 *
 * 拠点案内図 (mapImageUrl) を **2 枚目に固定**で差し込む (PIL-437)。
 * - ヒーロー画像が空: 案内図のみ (実質 1 枚目)
 * - ヒーロー画像が 1 枚以上: `[1 枚目, 案内図, 残り...]`
 *
 * mapImageUrl が未設定 (null/undefined/空文字) ならヒーロー画像をそのまま返す。
 */
export function buildSiteHeroImages(
  heroImages: readonly HeroImage[],
  mapImageUrl: string | null | undefined,
): HeroImage[] {
  if (!mapImageUrl) return [...heroImages];
  const mapImage: HeroImage = { url: mapImageUrl, caption: null };
  return [...heroImages.slice(0, 1), mapImage, ...heroImages.slice(1)];
}
